<template>
  <div class="callback-container">
    <div class="callback-box">
      <b-spinner v-if="loading" label="加载中..."></b-spinner>
      <div v-else>
        <h3>{{ message }}</h3>
        <p v-if="error">{{ errorMsg }}</p>
        <b-button v-if="error" @click="goToProfile" variant="primary">返回个人资料</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { request_zzquant } from 'network/request.js'

export default {
  data() {
    return {
      loading: true,
      message: '微信绑定处理中...',
      error: false,
      errorMsg: ''
    }
  },
  methods: {
    goToProfile() {
      this.$router.replace('/me/profile');
    },
    
    processWxBind(code) {
      request_zzquant({
        url: '/v2/login/wx/bind',
        method: 'POST',
        data: { code }
      })
      .then(res => {
        const data = res && res.data ? res.data : {}
        if (data.code === 20000) {
          this.message = '绑定成功，正在跳转...';
          
          // 更新本地用户信息的微信数据
          try {
             const raw = localStorage.getItem('user_info');
             const info = raw ? JSON.parse(raw) : {};
             if (data.data) {
                info.wx_name = data.data.wx_name;
                info.wx_avatar = data.data.wx_avatar;
             }
             localStorage.setItem('user_info', JSON.stringify(info));
             // 广播事件
             window.dispatchEvent(new CustomEvent('user-login', { detail: { userInfo: info } }));
          } catch(e) {
             console.warn('更新本地用户信息失败', e);
          }

          setTimeout(() => {
            this.$router.replace('/me/profile')
          }, 1500)
        } else {
          this.error = true;
          this.message = '绑定失败';
          this.errorMsg = data.message || '微信绑定处理失败';
        }
      })
      .catch(err => {
        console.error('微信绑定错误:', err);
        this.error = true;
        this.message = '绑定失败';
        this.errorMsg = err.message || '微信绑定处理出错，请稍后重试';
      })
      .finally(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    const code = this.$route.query.code;
    
    if (code) {
      this.processWxBind(code);
    } else {
      this.loading = false;
      this.error = true;
      this.message = '绑定失败';
      this.errorMsg = '未获取到微信授权码';
    }
  }
}
</script>

<style scoped>
.callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.callback-box {
  width: 400px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
}

h3 {
  margin-bottom: 20px;
}

p {
  color: #f56c6c;
  margin-bottom: 20px;
}
</style>
